export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
